import React, { useEffect, useState } from "react";
import { Phone, Menu, X, Zap } from "lucide-react";
import { companyInfo } from "../mock";

const navItems = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Why Us", href: "#why" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [active, setActive] = useState("Home");
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (label, href) => {
    setActive(label);
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#home" onClick={(e) => { e.preventDefault(); handleClick("Home", "#home"); }} className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-full bg-[#F5B800] flex items-center justify-center shadow-sm">
              <Zap className="w-6 h-6 text-[#0f2a5c]" fill="#0f2a5c" />
            </div>
            <div className="leading-tight">
              <div className="text-[#0f2a5c] font-extrabold text-xl tracking-wide">BRAHMA</div>
              <div className="text-[#0f2a5c] font-extrabold text-xl tracking-wide -mt-1">ELECTRICAL</div>
              <div className="text-[10px] text-slate-500 font-medium tracking-wider">Powering Your Future</div>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-9">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleClick(item.label, item.href); }}
                className={`link-underline text-[15px] font-medium transition-colors ${
                  active === item.label ? "text-[#0f2a5c] active" : "text-slate-700 hover:text-[#0f2a5c]"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Phone CTA */}
          <div className="flex items-center gap-3">
            <a
              href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}
              className="hidden md:inline-flex items-center gap-2 bg-[#0f2a5c] text-white font-semibold text-sm px-5 py-3 rounded-full hover:bg-[#0a1e42] transition-colors shadow-md"
            >
              <Phone className="w-4 h-4" />
              {companyInfo.phone}
            </a>
            <button
              onClick={() => setOpen(!open)}
              aria-label="Toggle Menu"
              className="lg:hidden p-2 text-[#0f2a5c]"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 px-6 py-4 space-y-3">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleClick(item.label, item.href); }}
              className={`block text-base font-medium py-1 ${active === item.label ? "text-[#0f2a5c]" : "text-slate-700"}`}
            >
              {item.label}
            </a>
          ))}
          <a
            href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}
            className="inline-flex md:hidden items-center gap-2 bg-[#0f2a5c] text-white font-semibold text-sm px-5 py-3 rounded-full"
          >
            <Phone className="w-4 h-4" />
            {companyInfo.phone}
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
